// src/components/StripeElementsWrapper.tsx
import React from "react";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";

export const CardNumberInput = ({ options, ...props }: any) => (
  <div {...props}>
    <CardNumberElement options={options} />
  </div>
);

export const CardExpiryInput = ({ options, ...props }: any) => (
  <div {...props}>
    <CardExpiryElement options={options} />
  </div>
);

export const CardCvcInput = ({ options, ...props }: any) => (
  <div {...props}>
    <CardCvcElement options={options} />
  </div>
);
